import {
  STOREFRONT_CONTRACT_VERSION,
  StorefrontSdkError,
  type StorefrontBootstrap,
} from "@emynor/storefront-sdk";

export async function loadStorefrontBootstrap(
  load: () => Promise<StorefrontBootstrap>,
): Promise<StorefrontBootstrap> {
  const bootstrap = await load();
  if (bootstrap.contractVersion !== STOREFRONT_CONTRACT_VERSION) {
    throw new StorefrontSdkError({
      code: "storefront_contract_unsupported",
      message: "This storefront version is not supported by the current application",
      status: 409,
    });
  }
  if (bootstrap.storefront && bootstrap.storefront.rendererKey !== "modern") {
    throw new StorefrontSdkError({
      code: "storefront_renderer_unsupported",
      message: "This storefront design is not supported by the current application",
      status: 409,
    });
  }
  return bootstrap;
}
